// extracted by mini-css-extract-plugin
export default {"wrapper":"xl08AghxNjJg230Lb6gI"};